import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=46db1a28&scoped=true"
import script from "./Dashboards.vue?vue&type=script&lang=js"
export * from "./Dashboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db1a28",
  null
  
)

export default component.exports